import { Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { DraftableStateTypes, Product, Routing, TId } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsRoutingsEditComponent } from './products-routings-edit/products-routings-edit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-products-routings',
    templateUrl: './products-routings.component.html',
    styleUrls: ['./products-routings.component.sass'],
    standalone: false
})
export class ProductsRoutingsComponent implements OnInit {
  @Input() productId: TId | undefined;

  config?: IGenericCrudConfiguration<Routing>;
  routings: Routing[];
  productSelected: Product;
  products: Product[];
  productRoutings: Routing[];

  states = DraftableStateTypes;

  constructor(private api: MasterApiService, private translateService: TranslateService) {
    this.routings = [];
    this.productSelected = {} as Product;
    this.products = [];
    this.productRoutings = [];

    this.states.forEach(x => x.displayName = this.translateService.instant(`enumeration.DraftableStateTypes.${x.name}`));
  }

  async getProduct(): Promise<void> {
    const product: any = await firstValueFrom(this.api.getProduct(this.productId!))
    this.productSelected = product
  }

  async getProductRoutings(): Promise<void> {
    this.productRoutings = await firstValueFrom(this.api.getRoutingsByProductId( { productId: this.productId! }))
  }

  async ngOnInit(): Promise<void>{
    await this.getProduct();
    await this.getProductRoutings();

    this.products = await firstValueFrom(this.api.resources.product.products.getAll())
    this.config = {
      name: this.api.resources.product.routings.resourceName,
      resource: this.api.resources.product.routings,
      data: this.productRoutings,
      isSearcherVisible: false,
      editComponent: {
        component: ProductsRoutingsEditComponent,
        inputPrms: {
          productSelected: this.productSelected
        }
      },
      entityFields: {
        name: {isLink: true},
        version: {},
        productId: {
          lookup: {
            dataSource: this.products,
            displayExpr: 'name',
            valueExpr: 'id'
          }
        },
        stateId: {
          lookup: {
            dataSource: this.states,
            displayExpr: 'displayName',
            valueExpr: 'id'
          }
        }
      }
    }
  }
}
